import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { firebaseApp } from "@/src/firebase";

let performanceStarted = false;

async function startPerformanceMonitoring() {
  if (!import.meta.env.PROD || performanceStarted) return;
  performanceStarted = true;

  try {
    const { getPerformance } = await import("firebase/performance");
    getPerformance(firebaseApp);
  } catch {
    // Observability must never interfere with the job-search experience.
  }
}

async function logPageView(path: string) {
  if (!import.meta.env.PROD || import.meta.env.VITE_FIREBASE_ANALYTICS_ENABLED !== "true") return;

  try {
    const { getAnalytics, isSupported, logEvent } = await import("firebase/analytics");
    if (!(await isSupported())) return;

    logEvent(getAnalytics(firebaseApp), "page_view", {
      page_location: window.location.href,
      page_path: path,
      page_title: document.title,
    });
  } catch {
    // Analytics is optional until the Firebase project is linked to GA.
  }
}

export function FirebaseObservability() {
  const location = useLocation();

  useEffect(() => {
    const start = () => void startPerformanceMonitoring();
    const idleWindow = window as unknown as {
      requestIdleCallback?: (callback: () => void) => number;
      cancelIdleCallback?: (id: number) => void;
    };

    if (idleWindow.requestIdleCallback && idleWindow.cancelIdleCallback) {
      const idleId = idleWindow.requestIdleCallback(start);
      return () => idleWindow.cancelIdleCallback?.(idleId);
    }

    const timeoutId = window.setTimeout(start, 1_000);
    return () => window.clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    void logPageView(`${location.pathname}${location.search}`);
  }, [location.pathname, location.search]);

  return null;
}
